import { jsx as _jsx } from "react/jsx-runtime";
import { Stack as MuiStack, } from '@mui/material';
import { forwardRef } from 'react';
export const Stack = forwardRef(function Stack(props, ref) {
    return _jsx(MuiStack, { ref: ref, ...props });
});
